<template>
    <div class="karaoke-row no-select"
         :class="`karaoke-row-${data.elId}`"
         :style="data.styleRect"
         :id="data.elId"
         ref="refKaraokeRow"
    >
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import cssvar from '@/scss/_variables.scss';
    import {usePaging} from "@/modules/reader/book/paging";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import {useMuteRoleControl} from "@/modules/reader/karaoke/muteRoleControl";

    const colorRect = cssvar.colorRect;
    const {pageResizeState} = usePageResize();
    const {getResizedAnnotationPos} = useAnnotationHelper();
    const { playBlockState, isInActiveMuteRoles, muteCurrentAudio, unmuteCurrentAudio} = usePlayBlockControl();

    export default {
        props: {
          annot:Object,
          sharedMeta:Object,
          pagenum:Number
        },
        setup(props, context) {

            const { readData} = useParser();
            const { pageState, setCurrentPage} = usePaging();
            const { bookInfoState} = useBookInfo();
            const { karaokeState, playParagraph} = useKaraokeControl();
            const { isInActiveMuteRoles, muteCurrentAudio, unmuteCurrentAudio} = useMuteRoleControl();
            const refKaraokeRow = ref(null);

            const data = reactive({
                elId: computed(()=>{
                    return `karaoke-row-${props.annot.karaokegrouptag}-${props.annot.rowindex}`;
                }),
                styleRect:computed(()=>{

                    let domPos = props.annot.domPos;
                    let resizedDomPos = getResizedAnnotationPos(domPos);
                    let width = 0;

                    let backgroundPosLeft = -1 * parseFloat(domPos.left)* pageResizeState.imgToBrowserScale;
                    let backgroundPosTop = -1 * parseFloat(domPos.top) * pageResizeState.imgToBrowserScale;

                    if (karaokeState.activeGrouptag === props.annot.karaokegrouptag) {
                        //if the current row has finished playing, it should display full width
                        if (props.annot.rowindex < karaokeState.currentRowIndex) {
                            //width = resizedDomPos.width;
                            width = karaokeState.currentParagraphRowElWidth[props.annot.rowindex];
                        //otherwise, extends the row width that sync with the audio
                        } else if (karaokeState.currentRowIndex === props.annot.rowindex) {
                            width = `${karaokeState.currentParagraphRowElWidth[karaokeState.currentRowIndex]}px`
                        }
                    }

                    return {
                       ...resizedDomPos,
                        width: width,
                        //width: resizedDomPos.width,
                        background: `url(${bookInfoState.publicPath}/${props.sharedMeta[props.annot.karaokegrouptag].bgImage})`,
                        backgroundSize: `${pageResizeState.baseWidth * pageResizeState.imgToBrowserScale}px ${pageResizeState.baseHeight * pageResizeState.imgToBrowserScale}px`,
                        backgroundPosition: `${backgroundPosLeft}px ${backgroundPosTop}px`,
                        position: "absolute",
                        //opacity:0.7
                    }

                }),
                audioId: computed(()=>{
                    return props.sharedMeta[props.annot.karaokegrouptag]["audioId"];
                }),
                wordAudioData: computed(()=>{
                    return  props.sharedMeta[props.annot.karaokegrouptag]["wordAudioData"][bookInfoState.activeSpeech];
                })
            });


            watchEffect(()=>{

                //check grouptag, active page number and row index altogether so that not all rows will be watched if the rows share the same grouptag
                if (karaokeState.activeGrouptag === props.annot.karaokegrouptag && karaokeState.activePageNum === props.pagenum && props.annot.rowindex  === karaokeState.currentRowIndex) {

                    //console.log("currentRole: " + props.sharedMeta[props.annot.karaokegrouptag]["roleId"])

                    if (isInActiveMuteRoles(props.pagenum,  props.sharedMeta[props.annot.karaokegrouptag]["roleId"])) {
                        muteCurrentAudio();
                    } else {
                        unmuteCurrentAudio();
                    }

                }
            })


            onMounted(() => {

            });

            return {
                data,
                refKaraokeRow,
                props,
                pageState,
                bookInfoState,
                karaokeState,
                setCurrentPage,
                playParagraph,
                getResizedAnnotationPos
            }

        }
    }

 </script>

<style lang="scss" scoped>

    .karaoke-row {
        z-index:1;
    }

</style>